import axios from 'axios';
import { VITE_REACT_API_PUBLIC_URL, VITE_REACT_API_URL } from 'src/private/config';

export const client = axios.create({
   baseURL: VITE_REACT_API_URL,
   headers: {
      Accept: 'application/json'
   },
   responseType: 'json'
});

export const clientPublic = axios.create({
   baseURL: `${VITE_REACT_API_PUBLIC_URL}`,
   headers: {
      Accept: 'application/json'
   },
   responseType: 'json'
});
